import { defineMessages } from 'react-intl';

export default defineMessages({
  maxProductQuantity: {
    id: 'app.modules.shopDetails.MaxProductQuantity.maxProductQuantity',
    defaultMessage: 'Máx {maxProductQuantity} unidades',
  },
  tooltipMessage: {
    id: 'app.modules.shopDetails.MaxProductQuantity.tooltipMessage',
    defaultMessage: 'Este local tiene un límite de unidades.',
  },
});
